module.exports = __webpack_public_path__ + "img/logo-comite15denoviembre.79d01b4a.png";